import Vue from 'vue';

/**
 * Queries for the app via component selector
 * @param {String} componentSelector
 * @returns {boolean} true if the app is found
 */
export const isVueAppInDOM = (componentSelector) =>
  !!document.querySelector(componentSelector);

/**
 * Creates an instance of a Vue app with the provided component as the root of the app,
 * targeting the element matching the given selector
 * @param {import('vue/types/umd').VueConstructor<Vue>} rootComponent
 * @param {string} selector
 */
export const renderApp = (rootComponent, selector) => 
  new Vue({
    render: (create) =>
      create(rootComponent, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);

/**
 * @typedef SelectOption
 * @property {string} name
 * @property {string} value
 */

/**
 * @typedef {SelectOption[]} SelectOptions
 */

/**
 * @param {string[]} enums
 * @returns {SelectOptions}
 */
export function mapEnumsToOptions(enums) {
  return enums.map((value) => ({
    value,
    name: value.replaceAll('_', ' ').trim(),
  }));
}
